/* ══════════════════════════════════════════════════════════════
   ED ERFAHRUNGEN – Script für alle ed-erf-* Sections
   1. Live-Zahlen aus REVIEWS.io (Ø + Anzahl, Shop- + Produktbewertungen, gleiche Quelle wie das Widget)
   2. Hero-Slider
   3. Bewertungs-Grid mit Filtern + "Mehr laden" (REVIEWS.io API)
   4. Instagram-Reels im Modal (Embed lädt erst nach Klick)
   5. Sanftes Einblenden beim Scrollen
   Wird von jeder Section eingebunden, läuft aber nur einmal.
   ══════════════════════════════════════════════════════════════ */
(function () {
  if (window.EDErf) { window.EDErf.init(document); return; }

  var API = 'https://api.reviews.io/';
  var STORE = 'www.everydays.de';
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Helfer ───────────────────────────────────────────────── */
  function fmtNumber(n, decimals) {
    return Number(n).toLocaleString('de-DE', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function getJSON(url) {
    return fetch(url, { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }
  function cacheGet(key, maxAgeMs) {
    try {
      var raw = sessionStorage.getItem(key);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (Date.now() - o.t > maxAgeMs) return null;
      return o.v;
    } catch (e) { return null; }
  }
  function cacheSet(key, v) {
    try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), v: v })); } catch (e) {}
  }
  var STAR_PATH = 'M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 21 12 17.77 5.82 21 7 14.14l-5-4.87 6.91-1.01L12 2z';
  function starsHTML(rating, sizeClass) {
    var pct = Math.max(0, Math.min(100, (Number(rating) / 5) * 100));
    var one = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + STAR_PATH + '"/></svg>';
    var row = one + one + one + one + one;
    return '<span class="ed-stars ' + (sizeClass || 'st-sm') + '" role="img" aria-label="' +
      fmtNumber(rating, Number(rating) % 1 ? 1 : 0) + ' von 5 Sternen">' +
      '<span class="ed-stars__row ed-stars__base">' + row + '</span>' +
      '<span class="ed-stars__row ed-stars__fill" style="width:' + pct + '%">' + row + '</span></span>';
  }

  /* ── 1. Live-Zahlen ───────────────────────────────────────── */
  var WORDS = { excellent: 'Hervorragend', great: 'Sehr gut', good: 'Gut', average: 'Durchschnittlich', poor: 'Schwach' };
  var statsPromise = null;
  function loadStats() {
    if (statsPromise) return statsPromise;
    var cached = cacheGet('edErfStats2', 60 * 60 * 1000);
    if (cached) { statsPromise = Promise.resolve(cached); return statsPromise; }
    var store = encodeURIComponent(STORE);
    // Gleiche Quelle wie das REVIEWS.io-Karussell-Widget (Shop- + Produktbewertungen in einer Zahl),
    // damit überall dieselbe Live-Zahl steht. Fallback: alte Summe aus merchant + product.
    var merchant = getJSON(API + 'merchant/latest?store=' + store).catch(function () { return {}; });
    statsPromise = Promise.all([
      merchant,
      getJSON(API + 'timeline/data?type=store_review&store=' + store + '&sort=date_desc&page=1&per_page=1&include_product_reviews=1')
    ]).then(function (res) {
      var st = res[1].stats || {};
      var count = Number(st.review_count) || 0;
      var avg = Number(st.average_rating) || 0;
      if (!count || !avg) throw new Error('keine Daten');
      return { count: count, avg: avg, word: WORDS[String(res[0].word || '').toLowerCase()] || '' };
    }).catch(function () {
      return Promise.all([
        merchant,
        getJSON(API + 'product/reviews/all?store=' + store + '&per_page=1')
      ]).then(function (res) {
        var shopCount = Number(res[0].stats && res[0].stats.total_reviews) || 0;
        var shopAvg = Number(res[0].stats && res[0].stats.average_rating) || 0;
        var prodCount = Number(res[1].count) || 0;
        var prodAvg = Number(res[1].rating) || 0;
        var count = shopCount + prodCount;
        if (!count) throw new Error('keine Daten');
        var avg = (shopCount * shopAvg + prodCount * prodAvg) / count;
        return { count: count, avg: avg, word: WORDS[String(res[0].word || '').toLowerCase()] || '' };
      });
    }).then(function (v) {
      cacheSet('edErfStats2', v);
      return v;
    });
    return statsPromise;
  }
  function applyStats(root) {
    var els = root.querySelectorAll('[data-ed-stat]');
    if (!els.length) return;
    loadStats().then(function (s) {
      Array.prototype.forEach.call(els, function (el) {
        var kind = el.getAttribute('data-ed-stat');
        if (kind === 'avg') {
          el.textContent = fmtNumber(s.avg, parseInt(el.getAttribute('data-decimals') || '1', 10));
        } else if (kind === 'count') {
          var step = parseInt(el.getAttribute('data-round') || '1', 10);
          var n = step > 1 ? Math.floor(s.count / step) * step : s.count;
          el.textContent = fmtNumber(n, 0);
        } else if (kind === 'word') {
          if (s.word) el.textContent = s.word;
        } else if (kind === 'stars') {
          var fill = el.querySelector('.ed-stars__fill');
          if (fill) fill.style.width = Math.min(100, (s.avg / 5) * 100) + '%';
          el.setAttribute('aria-label', fmtNumber(s.avg, 1) + ' von 5 Sternen');
        }
      });
    }).catch(function () { /* Fallback-Werte aus dem Theme-Editor bleiben stehen */ });
  }

  /* ── 2. Hero-Slider ───────────────────────────────────────── */
  function initSlider(el) {
    if (el.__edInit) return; el.__edInit = true;
    var slides = el.querySelectorAll('.slide');
    var dots = el.querySelectorAll('.dot');
    var nameEl = el.querySelector('[data-ed-slider-name]');
    if (slides.length < 2) return;
    var i = 0, timer = null;
    function show(n) {
      i = (n + slides.length) % slides.length;
      Array.prototype.forEach.call(slides, function (s, k) { s.classList.toggle('on', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      Array.prototype.forEach.call(dots, function (d, k) { d.classList.toggle('on', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (nameEl) nameEl.textContent = slides[i].getAttribute('data-name') || '';
    }
    function start() {
      if (reduceMotion || designMode) return;
      clearInterval(timer);
      timer = setInterval(function () { show(i + 1); }, 5000);
    }
    Array.prototype.forEach.call(dots, function (d) {
      d.addEventListener('click', function () { clearInterval(timer); show(parseInt(d.getAttribute('data-i'), 10)); start(); });
    });
    el.addEventListener('shopify:block:select', function (e) {
      var idx = Array.prototype.indexOf.call(slides, e.target.closest ? e.target.closest('.slide') : null);
      if (idx > -1) { clearInterval(timer); show(idx); }
    });
    show(0); start();
  }

  /* ── 3. Bewertungs-Grid ───────────────────────────────────── */
  function relTime(dateStr) {
    var d = new Date(String(dateStr).replace(' ', 'T'));
    if (isNaN(d)) return '';
    var days = Math.floor((Date.now() - d.getTime()) / 86400000);
    if (days < 1) return 'heute';
    if (days < 2) return 'gestern';
    if (days < 7) return 'vor ' + days + ' Tagen';
    if (days < 14) return 'vor einer Woche';
    if (days < 31) return 'vor ' + Math.floor(days / 7) + ' Wochen';
    if (days < 61) return 'vor einem Monat';
    if (days < 365) return 'vor ' + Math.floor(days / 30) + ' Monaten';
    if (days < 730) return 'vor einem Jahr';
    return 'vor ' + Math.floor(days / 365) + ' Jahren';
  }
  function cleanProduct(name) {
    // "smap® 3er Pack (27,95€ / Stück) - 20%" -> "smap® 3er Pack"
    return String(name || '').replace(/\s*\(.*?\)/g, '').replace(/\s+-\s+\d+\s*%.*$/, '').replace(/\s+\/\s+.*$/, '').trim();
  }
  function regify(html) { return html.replace(/®/g, '<span class="ed-reg">®</span>'); }
  function reviewCard(r, verifiedLabel, cfg) {
    var rv = r.reviewer || {};
    var first = (rv.first_name || '').trim();
    var last = (rv.last_name || '').trim();
    var name = first ? first + (last ? ' ' + last.charAt(0).toUpperCase() + '.' : '') : 'Anonym';
    var verified = rv.verified_buyer === 'yes' || rv.verified_buyer === true;
    var text = String(r.review || r.comments || '').trim();
    var long = text.length > 280;
    var map = cfg.skuMap || {};
    var product = cleanProduct(map[r.sku] || map[r.product] || r.name || r.product_name || '');
    return '<article class="card rev">' +
      '<div class="row between"><span class="txt strong">' + esc(name) + '</span>' + starsHTML(r.rating, 'st-sm') + '</div>' +
      (verified ? '<span class="pill" style="align-self:flex-start;">' + esc(verifiedLabel) + '</span>' : '') +
      (product ? '<p class="xs faint">' + regify(esc(product)) + '</p>' : '') +
      '<p class="sm rev-text">' + regify(esc(text)).replace(/\n+/g, '<br>') + '</p>' +
      (long ? '<button type="button" class="rev-more" data-ed-rev-more>Weiterlesen</button>' : '') +
      '<p class="xs faint" style="margin-top:auto;">' + esc(relTime(r.date_created)) + '</p>' +
      '</article>';
  }
  function initReviews(el) {
    if (el.__edInit) return; el.__edInit = true;
    var cfgEl = el.querySelector('script[data-ed-config]');
    if (!cfgEl) return;
    var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var grid = el.querySelector('[data-ed-reviews-list]');
    var moreBtn = el.querySelector('[data-ed-reviews-more]');
    var emptyEl = el.querySelector('[data-ed-reviews-empty]');
    var pills = el.querySelectorAll('[data-ed-filter]');
    // REVIEWS.io zählt Seiten ab 0 (page=0 = neueste Bewertungen)
    var state = { f: 0, page: 0, total: 1, loading: false, seen: {}, skips: 0 };

    function url() {
      var f = cfg.filters[state.f] || {};
      var u = API + 'product/reviews/all?store=' + encodeURIComponent(cfg.store || STORE) +
        '&per_page=' + (cfg.perPage || 8) + '&page=' + state.page;
      if (f.sku) u += '&sku=' + encodeURIComponent(f.sku);
      if (f.rating) u += '&rating=' + encodeURIComponent(f.rating);
      return u;
    }
    function skeleton(n) {
      var h = ''; for (var k = 0; k < n; k++) h += '<div class="card rev-skel" aria-hidden="true"></div>'; return h;
    }
    function load(reset) {
      if (state.loading) return;
      state.loading = true;
      if (reset) { state.page = 0; state.seen = {}; grid.innerHTML = skeleton(cfg.perPage || 8); }
      if (moreBtn) moreBtn.setAttribute('aria-busy', 'true');
      getJSON(url()).then(function (j) {
        if (reset) grid.innerHTML = '';
        state.total = Number(j.total_pages) || 1;
        var html = '';
        (j.reviews || []).forEach(function (r) {
          var id = r.product_review_id || r.store_review_id;
          if (state.seen[id]) return;
          state.seen[id] = true;
          if (cfg.hideEmpty && !String(r.review || '').trim()) return;
          if (cfg.lang) {
            // Sprach-Tags von REVIEWS.io (z. B. "de", "fr") – fremdsprachige ausblenden
            var langs = (r.tags || []).map(function (t) { return String(t.tag || t).toLowerCase(); })
              .filter(function (t) { return /^[a-z]{2}$/.test(t); });
            if (langs.length && langs.indexOf(cfg.lang) === -1) return;
          }
          html += reviewCard(r, cfg.verifiedLabel || 'Verifiziert', cfg);
        });
        grid.insertAdjacentHTML('beforeend', html);
        // Seite hatte nur ausgeblendete Bewertungen -> direkt die nächste holen
        if (!html && state.page < state.total - 1 && state.skips < 5) {
          state.skips += 1; state.page += 1; setTimeout(function () { load(false); }, 0); return;
        }
        state.skips = 0;
        var hasItems = !!grid.children.length;
        if (emptyEl) emptyEl.hidden = hasItems;
        if (moreBtn) moreBtn.hidden = state.page >= state.total - 1;
      }).catch(function () {
        if (reset) grid.innerHTML = '';
        if (emptyEl) emptyEl.hidden = !!grid.children.length;
        if (moreBtn) moreBtn.hidden = true;
      }).then(function () {
        state.loading = false;
        if (moreBtn) moreBtn.removeAttribute('aria-busy');
      });
    }
    Array.prototype.forEach.call(pills, function (p) {
      p.addEventListener('click', function () {
        var idx = parseInt(p.getAttribute('data-ed-filter'), 10);
        if (idx === state.f) return;
        state.f = idx;
        Array.prototype.forEach.call(pills, function (q) { q.setAttribute('aria-pressed', q === p ? 'true' : 'false'); });
        load(true);
      });
    });
    if (moreBtn) moreBtn.addEventListener('click', function () {
      if (state.page >= state.total - 1) return;
      state.page += 1; load(false);
    });
    grid.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-ed-rev-more]') : null;
      if (!b) return;
      var card = b.closest('.rev');
      var open = card.classList.toggle('is-open');
      b.textContent = open ? 'Weniger anzeigen' : 'Weiterlesen';
    });

    // Erst laden, wenn die Section in die Nähe des Viewports kommt
    if ('IntersectionObserver' in window && !designMode) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); load(true); }
      }, { rootMargin: '600px 0px' });
      io.observe(el);
    } else { load(true); }
  }

  /* ── 4. Reels ───────────────────────────────────────────────────── */
  var modal = null, lastFocus = null;
  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'ed-reel-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Instagram-Reel');
    modal.innerHTML = '<div class="ed-reel-modal__box"><button type="button" class="ed-reel-modal__close" aria-label="Schließen">&times;</button>' +
      '<div data-ed-reel-frame></div><a class="ed-reel-modal__ext" target="_blank" rel="noopener">Auf Instagram ansehen</a></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    modal.querySelector('.ed-reel-modal__close').addEventListener('click', closeModal);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal(); });
    return modal;
  }
  function openModal(embed, href) {
    var m = ensureModal();
    lastFocus = document.activeElement;
    m.querySelector('[data-ed-reel-frame]').innerHTML =
      '<iframe src="' + esc(embed) + '" title="Instagram-Reel" loading="lazy" allowfullscreen scrolling="no" allow="autoplay; encrypted-media; picture-in-picture"></iframe>';
    m.querySelector('.ed-reel-modal__ext').href = href;
    m.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    m.querySelector('.ed-reel-modal__close').focus();
  }
  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.querySelector('[data-ed-reel-frame]').innerHTML = '';
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function initReels(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-ed-reel]'), function (b) {
      if (b.__edInit) return; b.__edInit = true;
      b.addEventListener('click', function (e) {
        var embed = b.getAttribute('data-embed');
        if (!embed) return; // Link-Modus: normaler Link
        e.preventDefault();
        openModal(embed, b.getAttribute('href') || b.getAttribute('data-href'));
      });
    });
  }

  /* ── 5. Einblenden ────────────────────────────────────────── */
  var revealIO = null;
  function initReveal(root) {
    if (reduceMotion || designMode || !('IntersectionObserver' in window)) return;
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          Array.prototype.forEach.call(e.target.querySelectorAll('[data-reveal-child]'), function (c) { c.classList.add('is-in'); });
          revealIO.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    var seen = new Map();
    Array.prototype.forEach.call(root.querySelectorAll('.ed-erf [data-reveal]'), function (el) {
      if (el.__edReveal) return; el.__edReveal = true;
      var p = el.parentElement, i = seen.get(p) || 0; seen.set(p, i + 1);
      el.classList.add('reveal');
      if (i) el.style.transitionDelay = Math.min(i * 70, 280) + 'ms';
      Array.prototype.forEach.call(el.querySelectorAll('[data-reveal-child]'), function (c, k) {
        c.classList.add('reveal'); c.style.transitionDelay = (380 + k * 110) + 'ms';
      });
      revealIO.observe(el);
    });
  }

  function init(root) {
    root = root || document;
    applyStats(root);
    Array.prototype.forEach.call(root.querySelectorAll('[data-ed-slider]'), initSlider);
    Array.prototype.forEach.call(root.querySelectorAll('[data-ed-reviews-grid]'), initReviews);
    initReels(root);
    initReveal(root);
  }

  window.EDErf = { init: init, stats: loadStats };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
